import { useParams } from 'react-router-dom';

import { AppUpdateUserBadgePage } from '~/components/pages/AppUpdateUserBadgePage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateUserBadgeRoute: React.FC = () => {
  const { appId, userBadgeId } = useParams();
  const navigate = useNavigate();

  if (!appId || !userBadgeId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUpdateUserBadgePage appId={appId} userBadgeId={userBadgeId} />
    </DashboardTemplate>
  );
};
